import * as React from 'react';
// @ts-ignore
import styles from './PromoBox.module.scss?module';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClock } from '@fortawesome/pro-regular-svg-icons';

const PromoBox = ({
  text,
  availableShortly,
}: {
  text: string;
  availableShortly: boolean;
}) => {
  return (
    <>
      <div
        className={[
          'w-100 px-3 py-2',
          styles.promoBox,
          availableShortly ? styles.promoBoxAvailableShortly : '',
        ].join(' ')}
      >
        <span
          className={['d-block text-white fw-bold fst-italic text-center'].join(
            ' '
          )}
        >
          {text}
        </span>
      </div>
      {availableShortly && (
        <div className={styles.availableShortlyInfo}>
          <FontAwesomeIcon icon={faClock} />
          <span className={'ps-3'}>Available shortly</span>
        </div>
      )}
    </>
  );
};

export default PromoBox;
